import { Pause, Play } from 'lucide-react';
import './PlayPouseButton.css';

type Props = {
    isPlaying: boolean;
    togglePlay: () => void;
};

export function PlayPauseButton({ isPlaying, togglePlay }: Props) {
    return (
        <button className="playPauseButton" onClick={togglePlay} aria-label={isPlaying ? 'Pause' : 'Play'}>
            {isPlaying ? (
                <Pause size={20} strokeWidth={2.75} fill="currentColor" />
            ) : (
                <Play size={20} strokeWidth={2.75} fill="currentColor" />
            )}
        </button>
    );
}
